(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accordions"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = (root) => {
      root.querySelectorAll('.accordions[data-single-open]').forEach((group) => {
        group.querySelectorAll('details.accordion').forEach((details) => {
          if (details.closest('.accordions') === group) details.name = group.id;
        });
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
    } else {
      initialize(document);
    }
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
